import React, { useCallback, useContext } from "react";
import classNames from "classnames";
import { Link } from "../link";
import ProductPrice from "../product-price";
import useWhereToBuy from "../../hooks/use-where-to-buy";
import useReevooTrack from "../../hooks/use-reevoo-track";
import useStoreLocator from "../../hooks/use-store-locator";
import CartContext from "../../context/cart";
import WhereToBuyIcon from "../../icons/dove-acquistare.svg";
import CartIcon from "../../icons/carrello.svg";
import ButtonWTB from "../elements/button-wtb";
import { hasEcommerce } from "../../utility/ecommerce";
import useNoRtl from "../../hooks/use-no-rtl";

const externalPDPShopify = process.env.GATSBY_SHOPIFY_EXTERNAL_PDP || false;

const ProdottiActions = ({
  data,
  addCart,
  wtbAndRetailersActive,
  origin,
  link,
  labelManagerLabels,
  location,
  compare,
  show,
  isList,
  clickDetail,
  storeLink,
}) => {
  const enabledForLine = [undefined, "[]"].includes(
    data.pageLine?.lineConfigurationFieldSet?.isNotEcommerce?.[0]
  );
  const shopLink = data?.shopLink;

  const { assetId } = data;
  const ecommerceActive =
    enabledForLine &&
    (hasEcommerce ||
      (!hasEcommerce && data.sellingPrice?.value) ||
      (!hasEcommerce && shopLink && !data?.sellingPrice?.value));
  const { addProduct, adding, loadingCart } = useContext(CartContext);
  const onAddCart = useCallback(
    () => addProduct(data, null, location, origin),
    [addProduct, data, location, origin]
  );

  const reevooTrack = useReevooTrack(data.key_prod);
  const whereToBuyAssetId = useWhereToBuy(assetId);
  const storeLocatorPage = useStoreLocator();

  const noRtl = useNoRtl();

  return ecommerceActive || whereToBuyAssetId || show || storeLocatorPage ? (
    <div
      className={classNames(
        "prodotti__pricing",
        ecommerceActive && data.sellingPrice?.value === null && !data.shopLink
          ? compare
            ? "d-flex flex-column text-left mt-auto"
            : isList
            ? "d-flex flex-column text-center prodotti__pricing--with-price"
            : "d-flex flex-column text-center"
          : "prodotti__pricing--no-ecomm"
      )}
    >
      {!noRtl && (
        <ProductPrice
          data={enabledForLine && data.sellingPrice?.value ? data : null}
          compare={compare}
          contributoRaee={data?.contributoRaee}
        />
      )}
      <div
        className={classNames(
          "prodotti__actions d-flex flex-column align-items-center",
          {
            "prodotti__actions--noprice":
              !enabledForLine || (data.sellingPrice === null && !shopLink),
          },
          ecommerceActive && "mt-auto"
        )}
      >
        {addCart && !noRtl ? (
          <>
            {ecommerceActive || shopLink ? (
              <>
                {(data.sellingPrice?.value || shopLink) &&
                  (hasEcommerce &&
                  enabledForLine &&
                  data.sellingPrice?.value &&
                  !externalPDPShopify &&
                  data?.shopifyServices ? (
                    <a
                      href={data?.shopifyServices}
                      target="_self"
                      rel="noreferrer"
                      className={classNames(
                        "btn-link btn-link--blue button primary w-100 prodotti__add-cart align-self-center mt-2 ",
                        !wtbAndRetailersActive && "mb-5"
                      )}
                    >
                      <CartIcon />
                      {data.preorderActive === "true"
                        ? labelManagerLabels.preorder
                        : labelManagerLabels.addToCart}
                    </a>
                  ) : hasEcommerce &&
                    enabledForLine &&
                    data.sellingPrice?.value &&
                    !externalPDPShopify ? (
                    <button
                      className={classNames(
                        "btn-link btn-link--blue button primary w-100 prodotti__add-cart align-self-center mt-2 ",
                        !wtbAndRetailersActive && "mb-5"
                      )}
                      onClick={onAddCart}
                      disabled={!!adding || loadingCart}
                    >
                      <CartIcon />
                      {data.preorderActive === "true"
                        ? labelManagerLabels.preorder
                        : labelManagerLabels.addToCart}
                    </button>
                  ) : (
                    shopLink &&
                    externalPDPShopify && (
                      <a
                        href={shopLink}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-link btn-link--blue button primary w-100 prodotti__add-cart align-self-center mt-2"
                      >
                        <CartIcon />
                        {labelManagerLabels.buyOnHaierShop}
                      </a>
                    )
                  ))}
                {((!data.sellingPrice?.value && !data.shopLink) ||
                  (!!data.sellingPrice?.value &&
                    hasEcommerce &&
                    wtbAndRetailersActive &&
                    !!wtbAndRetailersActive?.length)) &&
                  (whereToBuyAssetId ? (
                    <ButtonWTB
                      className="prodotti__btn-wtb button tertiary w-100 mt-3 cswidget"
                      label={labelManagerLabels.whereToBuy}
                      reevooTrack={reevooTrack}
                      sku={data.key_prod}
                      assetId={whereToBuyAssetId}
                      location={location}
                      storeLink={storeLink}
                    />
                  ) : storeLocatorPage ? (
                    <Link
                      to={!!storeLink ? storeLink : storeLocatorPage}
                      target={!!storeLink ? "_blank" : "_self"}
                      className="prodotti__btn-wtb button tertiary w-100 mt-3"
                      rel="noreferrer"
                    >
                      <WhereToBuyIcon />
                      {labelManagerLabels.whereToBuy}
                    </Link>
                  ) : (
                    <div style={{ padding: "20px" }}></div>
                  ))}
              </>
            ) : whereToBuyAssetId ? (
              <ButtonWTB
                className="btn-link button primary btn-link--blue btn-link--mb w-100 mt-3 cswidget"
                label={labelManagerLabels.whereToBuy}
                reevooTrack={reevooTrack}
                sku={data.key_prod}
                assetId={whereToBuyAssetId}
                location={location}
                storeLink={storeLink}
              />
            ) : storeLocatorPage ? (
              <Link
                to={!!storeLink ? storeLink : storeLocatorPage}
                target={!!storeLink ? "_blank" : "_self"}
                className="btn-link button primary btn-link--blue btn-link--mb w-100 mt-3"
                rel="noreferrer"
              >
                <WhereToBuyIcon />
                {labelManagerLabels.buyNow}
              </Link>
            ) : null}
          </>
        ) : ecommerceActive && !noRtl ? (
          <>
            {(!!data.sellingPrice?.value || shopLink) &&
              !noRtl &&
              (enabledForLine &&
              data.sellingPrice?.value &&
              hasEcommerce &&
              (!shopLink || !externalPDPShopify) ? (
                <button
                  className={classNames(
                    "btn-link button primary btn-link--blue w-100 prodotti__add-cart align-self-center mt-2",
                    !wtbAndRetailersActive && "mb-5"
                  )}
                  onClick={onAddCart}
                  disabled={!!adding || loadingCart}
                >
                  <CartIcon />
                  {data.preorderActive === "true"
                    ? labelManagerLabels.preorder
                    : labelManagerLabels.addToCart}
                </button>
              ) : (
                shopLink && (
                  <a
                    href={shopLink}
                    target="_blank"
                    rel="noreferrer"
                    className="btn-link button primary btn-link--blue w-100 prodotti__add-cart align-self-center mt-2"
                  >
                    <CartIcon />
                    {labelManagerLabels.buyOnHaierShop}
                  </a>
                )
              ))}
            {(!data.shopLink &&
              !noRtl &&
              !!data.sellingPrice?.value &&
              hasEcommerce &&
              wtbAndRetailersActive &&
              !!wtbAndRetailersActive?.length) ||
              (!noRtl &&
                !!data.sellingPrice?.value &&
                hasEcommerce &&
                wtbAndRetailersActive &&
                !!wtbAndRetailersActive?.length &&
                externalPDPShopify &&
                shopLink &&
                (whereToBuyAssetId ? (
                  <ButtonWTB
                    className="prodotti__btn-wtb button tertiary w-100 mt-3 cswidget"
                    label={labelManagerLabels.whereToBuy}
                    reevooTrack={reevooTrack}
                    sku={data.key_prod}
                    assetId={whereToBuyAssetId}
                    location={location}
                    storeLink={storeLink}
                  />
                ) : storeLocatorPage ? (
                  <Link
                    to={!!storeLink ? storeLink : storeLocatorPage}
                    target={!!storeLink ? "_blank" : "_self"}
                    className="prodotti__btn-wtb button tertiary w-100 mt-3"
                    rel="noreferrer"
                  >
                    <WhereToBuyIcon />
                    {labelManagerLabels.whereToBuy}
                  </Link>
                ) : (
                  <div style={{ padding: "20px" }}></div>
                )))}
            {!data.sellingPrice?.value && link && (
              <Link
                to={link}
                onClick={clickDetail}
                className="btn-link button tertiary align-self-center mt-2 btn-link--mb"
                state={{ origin }}
              >
                {labelManagerLabels.showProduct}
              </Link>
            )}
          </>
        ) : (
          (data.sellingPrice === null || !enabledForLine || noRtl) &&
          link && (
            <Link
              to={link}
              onClick={clickDetail}
              className="btn-link button tertiary align-self-center mt-2 btn-link--mb"
              state={{ origin }}
            >
              {labelManagerLabels.showProduct}
            </Link>
          )
        )}
      </div>
    </div>
  ) : null;
};

export default ProdottiActions;
